import { createAction, props } from '@ngrx/store';
import { ReservationsBody } from '../states/filters-reservations.state';

export const SET_RESERVATIONS_FILTERS =
  '[STATEMENTS] Set statements filters';

export const setFiltersReservations = createAction(
  SET_RESERVATIONS_FILTERS,
  props<{ filtersReservations: ReservationsBody }>()
);
